import { useHistory } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect,useContext } from "react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import Context from "../Contex/Context";
import { useState } from "react";
import verified from '../Images/verifiedimage.svg'
export default function Verify(props) {
  const {setAuthenticate}=useContext(Context)
  const [status,setStatus]=useState(true)
  const { id } = props.match.params;
  const history = useHistory();
  useEffect(() => {
    axios
      .post(`${BaseUrl.baseurl}/email-marketing/user/verify-user/${id}`)
      .then((res) => {
        if (res.data.status) {
            localStorage.setItem("MailSenderuserDetails",JSON.stringify(res.data))
            setAuthenticate(true)
            history.push('/Email/accounts')
        }
        else
        {
          setStatus(false)
        }
      })
      .catch((err) => console.log("Error"));
  }, []);
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {status?
      <CircularProgress
      size={60}
      style={{
        color: "#1C485F",
      }}
    />:<div>
      <img src={verified} alt="" style={{height:'100%',width:'100%'}} loading="lazy" />
      <div className="textfoieldveri">Email Verification</div>
      <div className="textsubofemailverified"></div>
      </div>}
      
    </div>
  );
}
